<script setup>
import DataGrid from "@/components/common/other/DataGrid";
import {inject} from 'vue';
import {useStore} from 'vuex';

const shipments = inject("shipments");
const store = useStore();

</script>

<template class="cmp-collectionDelivery">

  <DataGrid
      :key="shipments.viewShipment.collectionAndDelivery.length"
      height="160"
      :selectable="false"
      :row-selection="false"
      :allow-grid-menu="false"
      :allowPagination="false"
      :columns="shipments.collectionDelivery.gridColumns"
      :dataSource="shipments.viewShipment.collectionAndDelivery">
  </DataGrid>

</template>

<style scoped>

</style>
